export default __webpack_public_path__ + "assets/images/6462ac7ff6f4be85e6d76184706394af.svg";